var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.167 12.833)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.6,22.667H8.583A1.585,1.585,0,0,1,7,21.083v-8.5A1.585,1.585,0,0,1,8.583,11h8.5a1.586,1.586,0,0,1,1.584,1.583V18.6a1.747,1.747,0,0,1-.511,1.238l-2.317,2.317A1.767,1.767,0,0,1,14.6,22.667Zm-6.018-10.5a.417.417,0,0,0-.417.416v8.5a.417.417,0,0,0,.417.417H14.6a.588.588,0,0,0,.413-.17l2.316-2.316A.586.586,0,0,0,17.5,18.6V12.583a.417.417,0,0,0-.417-.416Z",
    transform: "translate(-7 -11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.826 2.76)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.638,19.512a.588.588,0,0,1-.413-.17l-2.49-2.49a.583.583,0,0,1,.825-.825l2.049,2.049,3.948-4.51a.583.583,0,1,1,.877.769l-4.358,4.98a.579.579,0,0,1-.419.2h-.02Z",
    transform: "translate(-8.565 -13.366)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.083,27.667H2.917A2.92,2.92,0,0,1,0,24.75V4.917A2.92,2.92,0,0,1,2.917,2H25.083A2.92,2.92,0,0,1,28,4.917V24.75A2.92,2.92,0,0,1,25.083,27.667ZM2.917,3.167a1.752,1.752,0,0,0-1.75,1.75V24.75a1.752,1.752,0,0,0,1.75,1.75H25.083a1.752,1.752,0,0,0,1.75-1.75V4.917a1.752,1.752,0,0,0-1.75-1.75Z",
    transform: "translate(0 -2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.167)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.417,8.167H.583A.583.583,0,1,1,.583,7H27.417a.583.583,0,1,1,0,1.167Z",
    transform: "translate(0 -7)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.833)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.583,5.833A.584.584,0,0,1,5,5.25V.583a.583.583,0,0,1,1.167,0V5.25A.584.584,0,0,1,5.583,5.833Z",
    transform: "translate(-5)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.583,5.833A.584.584,0,0,1,18,5.25V.583a.583.583,0,1,1,1.167,0V5.25A.584.584,0,0,1,18.583,5.833Z",
    transform: "translate(-18)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.f66fd9bf8a3a66e5054c019fcda4d77e.svg";
export { ForwardRef as ReactComponent };